export const useOptions = () => {
    const i18n = useI18n();
    return {
        tasks: [
            { label: i18n.t("SequenceComplement"), value: "complement" },
            { label: i18n.t("ReverseComplement"), value: "reverse_complement" },
            { label: i18n.t("ReverseSequence"), value: "reverse" },
            { label: i18n.t("Translation"), value: "translation" },
        ],
    };
};
